module.exports = __webpack_public_path__ + "static/media/submitIcon.f8a754c3.svg";